import { Inject, Injectable } from '@angular/core';
import { Headers, Http, RequestOptions, Response } from '@angular/http';
import { JwtHelper } from 'angular2-jwt';
import { environment } from 'environments/environment';
import { Subject } from 'rxjs';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { StaticUrls } from '../models';
import { MyCookieService } from './my-cookie.service';

@Injectable()
export class AuthenticationService {

  private jwtHelper: JwtHelper = new JwtHelper();
  navigateAwaySelection$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private http: Http,
    @Inject(MyCookieService) private myCookieService: MyCookieService
  ) { }

  login(username: string, password: string): Observable<{msg:string, error:boolean}> {

    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });

    return this.http.post(StaticUrls._login, JSON.stringify({ 'username': username, 'password': password }),
      options).map((response: Response) => 
      {
        if (response.status === 200) 
        {
          if(this.myCookieService.token)
          {
            localStorage.setItem(environment.tokenName, response.text());
          }
          return {msg: '', error: false};
        } 
        else if (response.status === 204) 
        {
          return {msg: 'Username e/o password errati!', error: true};
        } 
        else 
        {
          return {msg: 'Errore!', error: true};
        }
      }).catch(this.handleError);
  }

  private handleError(error: Response | any) 
  {
    return Observable.throw(error);
  }

  logout(): void 
  {
    // per il logout cancello il token dal localStorage
    if(this.myCookieService.token)
    {
      localStorage.removeItem(environment.tokenName);
    }
  }

  role(): string {
    if (this.myCookieService.token){
      const token = localStorage.getItem(environment.tokenName);
      const profile = JSON.parse(this.jwtHelper.decodeToken(token).data4j);
      return profile.role;
    }
    return null;
  }
  
  /** 
   * Controlla che l'utente loggato abbia almeno uno dei ruoli indicati
  */
  is(...tipologiaUtente: string[]):boolean {
    if (this.myCookieService.token) {
      const token = localStorage.getItem(environment.tokenName);
      const profile = JSON.parse(this.jwtHelper.decodeToken(token).data4j);
      if (tipologiaUtente.findIndex(val=>val === profile.role) >= 0 ) {
        return true;
      } else { return false; }
    } else {
      return false;
    }
  }

}



// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/services/authentication.service.ts